import axios from "axios";
import { User, UserRole } from "../../../shared/types";
import { buildApiUrl } from "../config/api";

export interface UpdateUserRoleRequest {
  userId: string;
  role: UserRole;
}

export interface UsersResponse {
  users: User[];
  count: number;
  totalCount: number;
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

export interface GetAllUsersParams {
  page?: number;
  limit?: number;
  sortField?: string;
  sortDirection?: "asc" | "desc";
}

export class RoleManagementService {
  /**
   * Get all users (admin only)
   */
  static async getAllUsers(
    page?: number,
    limit?: number,
    sortField?: string,
    sortDirection?: "asc" | "desc"
  ): Promise<UsersResponse> {
    const params: Record<string, string | number> = {};
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (sortField) params.sortField = sortField;
    if (sortDirection) params.sortDirection = sortDirection;

    const response = await axios.get(buildApiUrl("admin/users"), { params });
    return response.data;
  }

  /**
   * Update user role (admin only)
   */
  static async updateUserRole(userId: string, role: UserRole): Promise<User> {
    const response = await axios.put(
      buildApiUrl(`admin/users/${userId}/role`),
      {
        role,
      }
    );
    return response.data.user;
  }

  /**
   * Get users by role (admin only)
   */
  static async getUsersByRole(role: UserRole): Promise<User[]> {
    const response = await axios.get(buildApiUrl(`admin/users?role=${role}`));
    return response.data.users;
  }
}
